import { apiClient } from '@/lib/api-client';
import type { ClinicSummary, User } from '@/types/api';

/** The platform console: every clinic (tenant) of Dentlog. */
export const platformApi = {
  async clinics() {
    const { data } = await apiClient.get<ClinicSummary[]>('/platform/clinics');
    return data;
  },
  async createClinic(input: {
    name: string;
    admin: { name: string; email: string; password: string };
  }) {
    const { data } = await apiClient.post<{ clinic: ClinicSummary; admin: User }>(
      '/platform/clinics',
      input
    );
    return data;
  },
  async updateClinic(id: string, patch: { name?: string; active?: boolean }) {
    const { data } = await apiClient.patch<ClinicSummary>(`/platform/clinics/${id}`, patch);
    return data;
  },
};
